// import { useData } from '@/contexts/DataContext';
import { demoData } from '../data/demo-data';
import {useData} from '../contexts/DataContext';

export const useDemoData = () => {
  const contextData = useData();
  
  return {
    // Context data (mutable)
    ...contextData,
    
    // Static demo data (immutable)
    assessments: demoData.assessments,
    weeklyProgress: demoData.weeklyProgress,
    academicPerformance: demoData.academicPerformance,
    careerPaths: demoData.careerPaths,
    leaderboard: demoData.leaderboard,
    chatMessages: demoData.chatMessages,
    
    // New school data
    schools: demoData.schools,
    schoolResponses: demoData.schoolResponses,

    // Helper methods for demo data management
    refreshData: contextData.generateNewDemoData,
    resetData: contextData.resetDemoData,
  };
};